import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';
import { StyledBlock, StyledTitle, StyledDescription } from '../StyledComponents';
import ActionsSection from '../ActionsSection';
import i18n from 'i18n';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

// TODO think about it
const parentalLockRating = [
  { title: i18n.t('pc.age.noLimits'), name: 'PG', analyticsValue: '0+' },
  { title: '12+', name: 'PG13', analyticsValue: '12+' },
  { title: '16+', name: 'R', analyticsValue: '16+' },
  { title: '18+', name: 'NC17', analyticsValue: '18+' },
];

export default class ParentalLockAgePage extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { age, showToast } = this.props;
    const { age: prevAge } = prevProps;

    if (age !== prevAge) {
      showToast({
        options: { toastText: i18n.t('pc.saveChanges') },
      });
    }
  }

  onBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  onEnter = ({ name: age, analyticsValue }) => {
    const { history, purchase, setParentalAge, setParentalIsEnabled } = this.props;

    setParentalAge(age);
    setParentalIsEnabled(purchase || age !== 'PG');

    innerAnalyticsVolia.postEvent({
      eventGroup: 'profile',
      eventName: `age restrictions`,
      eventValue: analyticsValue,
    });

    history.goBack();
  };

  render() {
    const { age } = this.props;

    return (
      <>
        <BackButton onEnter={this.onBack} />
        <div>
          <StyledBlock>
            <StyledTitle>{i18n.t('pc.age.title')}</StyledTitle>
          </StyledBlock>
          <StyledBlock>
            <StyledDescription>{i18n.t('pc.age.chooseLimits')}</StyledDescription>
          </StyledBlock>
          <StyledBlock>
            <ActionsSection defaultSection>
              {parentalLockRating.map(item => (
                <ActionsSection.Button
                  onEnter={() => this.onEnter(item)}
                  key={item.name}
                  label={item.title}
                  type={'tick-button'}
                  selected={item.name === age}
                />
              ))}
            </ActionsSection>
          </StyledBlock>
        </div>
      </>
    );
  }
}

ParentalLockAgePage.propTypes = {
  history: PropTypes.object.isRequired,
  setParentalAge: PropTypes.func.isRequired,
  setParentalIsEnabled: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired,
};
